import agent, { prepareHeaders } from 'api/agent';
import { AppDownloadLink, AppVersion, DistributionApp, GitHubTokenStatus } from 'api/models';

const PATH = '/app-updates';

export const AppUpdates = {
    GetVersions: (app: DistributionApp): Promise<AppVersion[]> =>
        agent.requests.get(`${PATH}/${app}/versions`),
    SetEnrollment: (app: DistributionApp, fullVersion: string, enrolled: boolean): Promise<void> =>
        agent.requests.put(
            `${PATH}/${app}/versions/${encodeURIComponent(fullVersion)}/enrollment`,
            { enrolled },
            prepareHeaders()
        ),
    GetVersionDownloadLink: (app: DistributionApp, fullVersion: string): Promise<AppDownloadLink> =>
        agent.requests.get(`${PATH}/${app}/versions/${encodeURIComponent(fullVersion)}/download`),
    GetTokenStatus: (): Promise<GitHubTokenStatus> => agent.requests.get(`${PATH}/github-token`),
    SaveToken: (token: string): Promise<void> =>
        agent.requests.put(`${PATH}/github-token`, { token }, prepareHeaders()),
};
